import React from 'react';
import { Link } from 'react-router-dom';

const PEOPLE = [
  {
    name: 'Mohammad Fowzan',
    role: 'Founder',
    bio: 'Computer science undergraduate specializing in AI, machine learning, and deep learning. Building the systems Cognitics needs to take mental health from intuition to measurement.',
  },
  {
    name: 'Syed Mohtashim',
    role: 'Founder',
    bio: 'Computer science postgraduate focused on AI in mental health. Anchoring the research methodology behind Bloora and Cognitics’ clinical work.',
  },
];

export default function TeamTeaser() {
  return (
    <section className="py-24 md:py-32 px-6">
      <div className="max-w-6xl mx-auto">
        <div className="mb-16 flex flex-col md:flex-row md:items-end md:justify-between gap-6">
          <div>
            <span className="text-xs uppercase tracking-[0.3em] text-gray-500">
              Leadership
            </span>
            <h2 className="text-4xl md:text-5xl font-light mt-4 mb-6">
              Founders
            </h2>
            <div className="w-24 h-px bg-gray-900" />
          </div>
          <Link to="/company" className="text-gray-700 hover:text-gray-900 text-sm uppercase tracking-widest">
            Meet the team →
          </Link>
        </div>

        <div className="grid md:grid-cols-2 gap-8">
          {PEOPLE.map((p) => (
            <div
              key={p.name}
              className="p-8 md:p-10 border border-gray-200 hover:shadow-md transition-all duration-300"
              style={{ backgroundColor: '#fbfcf3' }}
            >
              <div className="flex items-start space-x-4 mb-6">
                <div className="w-14 h-14 bg-gray-200 flex items-center justify-center text-xl font-light text-gray-600">
                  {p.name.split(' ').map((n) => n[0]).join('')}
                </div>
                <div>
                  <h3 className="text-xl font-light mb-1">{p.name}</h3>
                  <p className="text-xs text-gray-500 uppercase tracking-wider">{p.role}</p>
                </div>
              </div>
              <p className="text-gray-700 leading-relaxed">{p.bio}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
